import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import ImageUpload from '../../components/admin/ImageUpload';
import { Save } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminAbout = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState({
    id: null,
    intro_en: '',
    intro_tr: '',
    paragraph1_en: '',
    paragraph1_tr: '',
    paragraph2_en: '',
    paragraph2_tr: '',
    paragraph3_en: '',
    paragraph3_tr: '',
    reasons_en: ['', '', '', ''],
    reasons_tr: ['', '', '', ''],
    main_image: '',
    gallery_images: ['', '', '']
  });

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${BACKEND_URL}/api/admin/about`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data) {
        setContent(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(`${BACKEND_URL}/api/admin/about`, content, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Hakkımızda içeriği kaydedildi');
    } catch (error) {
      toast.error('Kaydetme hatası');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading">Yükleniyor...</div>;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Hakkımızda İçeriği Düzenle</h1>
        <button onClick={handleSave} disabled={saving} className="btn-primary">
          <Save size={20} />
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </div>

      <div className="admin-form">
        <div className="form-section">
          <h3>Ana Görsel</h3>
          <ImageUpload
            currentImage={content.main_image}
            onImageUploaded={(url) => setContent({ ...content, main_image: url })}
          />
        </div>

        <div className="form-section">
          <h3>Giriş Başlığı</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <input
                type="text"
                value={content.intro_en}
                onChange={(e) => setContent({ ...content, intro_en: e.target.value })}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <input
                type="text"
                value={content.intro_tr}
                onChange={(e) => setContent({ ...content, intro_tr: e.target.value })}
                className="form-input"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Paragraf 1</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <textarea
                value={content.paragraph1_en}
                onChange={(e) => setContent({ ...content, paragraph1_en: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <textarea
                value={content.paragraph1_tr}
                onChange={(e) => setContent({ ...content, paragraph1_tr: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Paragraf 2</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <textarea
                value={content.paragraph2_en}
                onChange={(e) => setContent({ ...content, paragraph2_en: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <textarea
                value={content.paragraph2_tr}
                onChange={(e) => setContent({ ...content, paragraph2_tr: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Paragraf 3</h3>
          <div className="form-row">
            <div className="form-group">
              <label>İngilizce</label>
              <textarea
                value={content.paragraph3_en}
                onChange={(e) => setContent({ ...content, paragraph3_en: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
            <div className="form-group">
              <label>Türkçe</label>
              <textarea
                value={content.paragraph3_tr}
                onChange={(e) => setContent({ ...content, paragraph3_tr: e.target.value })}
                rows="4"
                className="form-textarea"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Neden EDGE MARINE (4 Madde)</h3>
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="form-row" style={{ marginBottom: '1rem' }}>
              <div className="form-group">
                <label>İngilizce {index + 1}</label>
                <input
                  type="text"
                  value={content.reasons_en[index] || ''}
                  onChange={(e) => {
                    const newReasons = [...content.reasons_en];
                    newReasons[index] = e.target.value;
                    setContent({ ...content, reasons_en: newReasons });
                  }}
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Türkçe {index + 1}</label>
                <input
                  type="text"
                  value={content.reasons_tr[index] || ''}
                  onChange={(e) => {
                    const newReasons = [...content.reasons_tr];
                    newReasons[index] = e.target.value;
                    setContent({ ...content, reasons_tr: newReasons });
                  }}
                  className="form-input"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="form-section">
          <h3>Galeri Görselleri (3 Adet)</h3>
          <div className="gallery-grid">
            {[0, 1, 2].map((index) => (
              <ImageUpload
                key={index}
                currentImage={content.gallery_images[index]}
                onImageUploaded={(url) => {
                  const newImages = [...content.gallery_images];
                  newImages[index] = url;
                  setContent({ ...content, gallery_images: newImages });
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAbout;
